import { render, staticRenderFns } from "./ClassificationGroupsList.vue?vue&type=template&id=03a15a1f&"
import script from "./ClassificationGroupsList.vue?vue&type=script&lang=js&"
export * from "./ClassificationGroupsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports